import React from 'react'
import { Tag, Button, Space, Tooltip } from 'antd'
import { FolderOutlined, FolderOpenOutlined } from '@ant-design/icons'
import Delete from '~/components/deleteConfirm'

export const getColumns = (
	handleToGo,
	handleDelete,
	setMoveNode,
	sortTable,
	selectedDocuments,
	loggedUser,
	columnsConfig,
	currentOrderBy,
	currentOrder
) => {
	let columns = []
	if (!columnsConfig) {
		return columns
	}

	function getRender(column, text, row) {
		if (column.name === 'title') {
			return (
				<Space size="small">
					{row.is_folder ? <FolderOutlined /> : null}
					<Button type="link" onClick={() => handleToGo(row)}>
						{text}
					</Button>
				</Space>
			)
		} else if (column.name === 'status') {
			var color = ''
			switch (text) {
				case 'Análise Jurídico':
					color = 'geekblue'
					break
				case 'Análise Diretoria':
					color = 'orange'
					break
				case 'Ativo':
					color = 'purple'
					break
				case 'Em revisão':
					color = 'pink'
					break
				case 'Enviado para assinatura':
					color = 'volcano'
					break
				case 'Assinado':
					color = 'green'
					break
				case 'Arquivado':
					color = 'blue'
					break
				default:
					color = ''
			}
			if (color) {
				return (
					<Tag color={color} key={text}>
						{text}
					</Tag>
				)
			} else {
				return text
			}
		} else {
			return text
		}
	}

	columnsConfig.forEach((columnConfig) => {
		if (columnConfig.is_active === true) {
			columns.push({
				title: columnConfig.display_name,
				dataIndex: columnConfig.name,
				key: columnConfig.name,
				render: (text, row) => getRender(columnConfig, text, row),
				sorter: columnConfig.is_sortable,
				sortOrder: currentOrderBy === columnConfig.sort_name && currentOrder,
				onHeaderCell: (column) => {
					return {
						onClick: () => {
							sortTable(columnConfig.sort_name)
						},
					}
				},
			})
		}
	})

	columns.push({
		title: '',
		dataIndex: 'action',
		key: 'action',
		render: (text, row) => {
			const isSelected = selectedDocuments.includes(row.id)

			function returnCompanyAdminNodes() {
				return (
					<Space size="middle">
						{isSelected ? (
							<Delete
								title={`Deseja excluir os ${selectedDocuments.length} itens selecionados?`}
								handle={() => handleDelete(selectedDocuments)}
								tooltip={{
									title: 'Deletar selecionados',
								}}
							/>
						) : (
							<Delete
								title={
									row.is_folder
										? 'Deseja excluir essa pasta?'
										: 'Deseja excluir esse documento?'
								}
								handle={() => handleDelete(row)}
							/>
						)}
						<Tooltip title={isSelected ? '' : 'Mover para outra pasta'}>
							<FolderOpenOutlined
								style={{
									fontSize: '20px',
									color: isSelected ? 'lightgray' : 'var(--ant-primary-color)',
									verticalAlign: 'middle',
									margin: 'auto',
								}}
								onClick={isSelected ? undefined : () => setMoveNode(row)}
							/>
						</Tooltip>
					</Space>
				)
			}

			function returnNormalUserNodes() {
				return (
					<Space size="middle">
						<Tooltip title={isSelected ? '' : 'Mover para outra pasta'}>
							<FolderOpenOutlined
								style={{
									fontSize: '20px',
									color: isSelected ? 'lightgray' : 'var(--ant-primary-color)',
									verticalAlign: 'middle',
									margin: 'auto',
								}}
								onClick={isSelected ? undefined : () => setMoveNode(row)}
							/>
						</Tooltip>
					</Space>
				)
			}

			return loggedUser.is_company_admin
				? returnCompanyAdminNodes()
				: returnNormalUserNodes()
		},
	})
	return columns
}
